import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
import * as React from 'react';
const Label = React.forwardRef(({ className, ...props }, ref) => {
    return (_jsx("label", { ref: ref, className: clsx('text-sm font-medium leading-none text-gray-700', 'peer-disabled:cursor-not-allowed peer-disabled:opacity-70', className), ...props }));
});
Label.displayName = 'Label';
export { Label };
